/** @jsxImportSource @emotion/react */
import { SerializedStyles } from "@emotion/react";
import { MODAL_SIZE } from "../layout/modal/modalSize";
import ModalView, { ModalContent } from "../layout/modal/ModalView";
import { useSelector } from "react-redux";
import { IAppState } from "../core/redux/IAppState";
import { getResource } from "../language/resources/getResource";
import { COLUMN_SPACING } from "../forms/styles";
import ModalTitleHeader from "../layout/modal/ModalTitleHeader";
import editIcon from "../assets/icons/edit.svg";
import { LiftAccessRuleSetEditor } from "./accessRules/liftAccessRuleSet/LiftAccessRuleSetEditor";
import { LiftAccessRuleSet } from "./accessRules/liftAccessRuleSet/models";

type Props = {
  ruleSet: LiftAccessRuleSet;
  dismissable?: boolean;
  onDismiss: () => void;
  onCommit?: () => void;
  onDelete?: () => void;
  rootCss?: SerializedStyles;
};

export const AccessIndividualEditModal = (props: Props) => {
  const resources = useSelector((state: IAppState) => state.locale);

  return (
    <ModalView
      dismissable={props.dismissable}
      onDismiss={props.onDismiss}
      disableClickoffDismissable={true}
      rootCss={props.rootCss}
      size={MODAL_SIZE.LARGE}
      contentCss={COLUMN_SPACING}
    >
      <ModalTitleHeader
        resources={resources}
        heading={getResource(resources, "ACCESS_RULE_EDIT_MODAL_TITLE")}
        icon={editIcon}
        onDismiss={props.onDismiss}
      />
      <ModalContent>
        <LiftAccessRuleSetEditor
          ruleSet={props.ruleSet}
          onDismiss={props.onDismiss}
          onSave={props.onCommit}
          onDelete={props.onDelete}
        />
      </ModalContent>
    </ModalView>
  );
};
